import { FC, forwardRef, PropsWithChildren, RefObject } from 'react';
import classNames from 'classnames';

import { Typography } from '../Typography/Typography';

import './CustomRadio.css';

type CustomRadioProps = Omit<React.InputHTMLAttributes<HTMLInputElement>, 'type'> &
	PropsWithChildren & {
		id?: string;
		width?: string;
		className?: string;
		labelClassName?: string;
	};
export const CustomRadio: FC<CustomRadioProps> = forwardRef(
	({ id, width, children, className, labelClassName, ...props }, ref) => {
		const { Text } = Typography;

		return (
			<div className='radio_btn'>
				<input
					id={id}
					type='radio'
					ref={ref as RefObject<HTMLInputElement>}
					className='radio_input'
					{...props}
				/>
				<label
					htmlFor={id}
					className={classNames(
						labelClassName,
						`radio-btn__content`,
						props.disabled && `radio-btn__content--disabled`,
					)}
					style={{ width }}
				>
					<Text className={className} as='div'>
						{children}
					</Text>
				</label>
			</div>
		);
	},
);
